import { redirect, createFileRoute } from '@tanstack/react-router'
import { getOidc } from '@/features/oidc/oidc'

export const Route = createFileRoute('/login')({
  beforeLoad: async () => {
    const oidc = await getOidc()

    if (oidc.isUserLoggedIn) {
      return redirect({ to: '/' })
    }

    await oidc.login({ doesCurrentHrefRequiresAuth: false })
  },
})
